export function add(text) {
  navigator.clipboard.writeText(text);
}